import React from "react";
import Layouts from "./layout/Layout";
import { Route, Routes } from "react-router-dom";
import RegisterMain from "./pages/register/RegisterMain";
import Home from "./pages/Home";
import RegisterMember1 from "./pages/register/RegisterMember1";
import RegisterMember2 from "./pages/register/RegisterMember2";
import RegisterMember3 from "./pages/register/RegisterMember3";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import RegisterShop1 from "./pages/register/RegisterShop1";
import RegisterShop2 from "./pages/register/RegisterShop2";
import RegisterShop3 from "./pages/register/RegisterShop3";
import RegisterSuccess from "./pages/register/RegisterSuccess";
import { useLiff } from "react-liff";
import { CircularProgress } from "@mui/joy";
import MemberInfoMain from "./pages/member-info/MemberInfoMain";
import MemberInfoEditProfile from "./pages/member-info/MemberInfoEditProfile";
import MemberInfoEditAddress from "./pages/member-info/MemberInfoEditAddress";
import LoadingMain from "./components/dialog/LoadingMain";
import CopyTag from "./pages/i-frame/copy-tag";
import Game01 from "./pages/auth-redirect/Game01";
import ShopInfoMain from "./pages/shop-info/ShopInfoMain";
import LuckyDrawMain from "./pages/lucky-draw/LuckyDrawMain";
import LuckyDrawForm from "./pages/lucky-draw/LuckyDrawForm";
import LuckyDrawSuccess from "./pages/lucky-draw/LuckyDrawSuccess";
import LuckyDrawMenu from "./pages/lucky-draw/LuckyDrawMenu";
import LuckyDrawHistory from "./pages/lucky-draw/LuckyDrawHistory";
import LuckyDrawHistoryDetail from "./pages/lucky-draw/LuckyDrawHistoryDetail";
import LuckyDrawResult from "./pages/lucky-draw/LuckyDrawResult";
import BingoMain from "./pages/bingo/BingoMain";
import BingoResult from "./pages/bingo/BingoResult";
import BingoSuccess from "./pages/bingo/BingoSuccess";
import BingoReward from "./pages/bingo/BingoReward";
import MemberCouponMain from "./pages/coupon/MemberCouponMain";
import MemberCouponDetail from "./pages/coupon/MemberCouponDetail";
import MemberCouponOnlineDetail from "./pages/coupon/MemberCouponOnlineDetail";
import MemberCouponQrCode from "./pages/coupon/MemberCouponQrCode";
import MemberCouponSuccess from "./pages/coupon/MemberCouponSuccess";
import ShopCouponMain from "./pages/coupon/ShopCoupon";
import ShopAddCoupon from "./pages/coupon/ShopAddCoupon";

import UserProducts from "./pages/User-Products/User-Products";
import AddProducts from "./pages/User-Products/Add-Products";
import NotifyRepair from "./pages/User-Products/Notify-Repair";
import ProductsDetail from "./pages/User-Products/Products-Detail";

// import Test from "./pages/coupon/test";
import ShopCouponDetail from "./pages/coupon/ShopCouponDetail";
import ShopScanQrCode from "./pages/coupon/ShopScanQrCode";
import ShopCouponSuccess from "./pages/coupon/ShopCouponSuccess";
import ShopCouponConfirm from "./pages/coupon/ShopCouponConfirm";
import ShopInfoEditProfile from "./pages/shop-info/ShopInfoEditProfile";
import ShopInfoEditAddress from "./pages/shop-info/ShopInfoEditAddress";
import EmployeeList from "./pages/employee/EmployeeList";
import PrizeList from "./pages/prize/PrizeList";
import PrizeDetail from "./pages/prize/PrizeDetail";
import PrizeSuccess from "./pages/prize/PrizeSuccess";
import PrizeAddress from "./pages/prize/PrizeAddress";
import PrizeHistory from "./pages/prize/PrizeHistory";
import LuckyDrawResultDetail from "./pages/lucky-draw/LuckyDrawResultDetail";
import QuestionnairePreview from "./pages/register/QuestionairPreview";
import BingoDetail from "./pages/bingo/BingoDetail";
import CropImage from "./pages/coupon/CropImage";

const theme = createTheme({
  typography: {
    fontFamily: `'Kittithada Roman 55', 'Kanit', sans-serif`,
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

function App() {
  const { isLoggedIn, liff } = useLiff();

  window.localStorage.removeItem("sub");
  if (isLoggedIn) {
    const sub = liff.getDecodedIDToken().sub;
    window.localStorage.setItem("sub", sub);
  }

  return (
    <>
      {isLoggedIn && (
        <ThemeProvider theme={theme}>
          <Layouts>
            {/* <WelcomeBackPopup /> ทำทุกหน้า */}
            <LoadingMain />
            <Routes>
              <Route path="/" exact element={<Home />} />
              <Route path="/register" element={<RegisterMain />} />
              <Route path="/register-member-1" element={<RegisterMember1 />} />
              <Route path="/register-member-2" element={<RegisterMember2 />} />
              <Route path="/register-member-3" element={<RegisterMember3 />} />
              <Route path="/register-shop-1" element={<RegisterShop1 />} />
              <Route path="/register-shop-2" element={<RegisterShop2 />} />
              <Route path="/register-shop-3" element={<RegisterShop3 />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/register-success" element={<RegisterSuccess />} />
              <Route path="/lucky-draw" element={<LuckyDrawMain />} />
              <Route path="/lucky-draw-form" element={<LuckyDrawForm />} />
              <Route path="/lucky-draw-success" element={<LuckyDrawSuccess/>} />
              <Route path="/event" element={<LuckyDrawMenu/>} />
              <Route path="/lucky-draw-history" element={<LuckyDrawHistory/>} />
              <Route path="/lucky-draw-history-detail" element={<LuckyDrawHistoryDetail/>} />
              <Route path="/lucky-draw-result" element={<LuckyDrawResult/>} />
              <Route path="/lucky-draw-result-detail" element={<LuckyDrawResultDetail/>} />
              <Route path="/bingo" element={<BingoMain/>} />
              <Route path="/bingo-detail" element={<BingoDetail/>} />
              <Route path="/bingo-result" element={<BingoResult/>} />
              <Route path="/bingo-success" element={<BingoSuccess/>} />
              <Route path="/bingo-reward" element={<BingoReward/>} />
              <Route path="/member-coupon" element={<MemberCouponMain/>} />
              <Route path="/member-coupon-detail" element={<MemberCouponDetail/>} />
              <Route path="/member-coupon-online-detail" element={<MemberCouponOnlineDetail/>} />
              <Route path="/member-coupon-qr-code" element={<MemberCouponQrCode/>} />
              <Route path="/member-coupon-success" element={<MemberCouponSuccess/>} />
              <Route path="/shop-coupon" element={<ShopCouponMain/>} />
              <Route path="/shop-add-coupon" element={<ShopAddCoupon/>} />
              <Route path="/shop-coupon-detail" element={<ShopCouponDetail/>} />
              <Route path="/shop-scan-qr-code" element={<ShopScanQrCode/>} />
              <Route path="/shop-coupon-confirm" element={<ShopCouponConfirm/>} />
              <Route path="/shop-coupon-success" element={<ShopCouponSuccess/>} />
              <Route path="/crop-image" element={<CropImage/>} />
              <Route path="/shop-info-edit-profile" element={<ShopInfoEditProfile/>} />
              <Route path="/shop-info-edit-address" element={<ShopInfoEditAddress/>} />
              <Route path="/shop-employee" element={<EmployeeList/>} />
              <Route path="/prize" element={<PrizeList/>} />
              <Route path="/prize-detail" element={<PrizeDetail/>} />
              <Route path="/prize-address" element={<PrizeAddress/>} />
              <Route path="/prize-success" element={<PrizeSuccess/>} />
              <Route path="/prize-history" element={<PrizeHistory/>} />
              <Route path="/questionair-preview/:qId" element={<QuestionnairePreview />} />
              {/* <Route path="/test" element={<Test/>} /> */}
              
              <Route
                path="/lucky-draw-success"
                element={<LuckyDrawSuccess />}
              />
              <Route path="/event" element={<LuckyDrawMenu />} />
              <Route
                path="/lucky-draw-history"
                element={<LuckyDrawHistory />}
              />
              <Route
                path="/lucky-draw-history-detail"
                element={<LuckyDrawHistoryDetail />}
              />
              <Route path="/lucky-draw-result" element={<LuckyDrawResult />} />
              <Route path="/bingo" element={<BingoMain />} />
              <Route path="/bingo-result" element={<BingoResult />} />
              <Route path="/bingo-success" element={<BingoSuccess />} />
              <Route path="/bingo-reward" element={<BingoReward />} />
              <Route path="/member-coupon" element={<MemberCouponMain />} />
              <Route
                path="/member-coupon-detail"
                element={<MemberCouponDetail />}
              />
              <Route
                path="/member-coupon-qr-code"
                element={<MemberCouponQrCode />}
              />
              <Route
                path="/member-coupon-success"
                element={<MemberCouponSuccess />}
              />
              <Route path="/shop-coupon" element={<ShopCouponMain />} />
              <Route path="/shop-add-coupon" element={<ShopAddCoupon />} />
              <Route
                path="/lucky-draw-success"
                element={<LuckyDrawSuccess />}
              />
              <Route path="/event" element={<LuckyDrawMenu />} />
              <Route
                path="/lucky-draw-history"
                element={<LuckyDrawHistory />}
              />
              <Route
                path="/lucky-draw-history-detail"
                element={<LuckyDrawHistoryDetail />}
              />
              <Route path="/lucky-draw-result" element={<LuckyDrawResult />} />
              <Route path="/bingo" element={<BingoMain />} />
              <Route path="/bingo-result" element={<BingoResult />} />
              <Route path="/bingo-success" element={<BingoSuccess />} />
              <Route path="/bingo-reward" element={<BingoReward />} />
              <Route path="/member-coupon" element={<MemberCouponMain />} />
              <Route
                path="/member-coupon-detail"
                element={<MemberCouponDetail />}
              />
              <Route
                path="/member-coupon-qr-code"
                element={<MemberCouponQrCode />}
              />
              <Route
                path="/member-coupon-success"
                element={<MemberCouponSuccess />}
              />
              <Route path="/shop-coupon" element={<ShopCouponMain />} />
              <Route path="/shop-add-coupon" element={<ShopAddCoupon />} />
              <Route
                path="/shop-coupon-detail"
                element={<ShopCouponDetail />}
              />
              <Route path="/shop-scan-qr-code" element={<ShopScanQrCode />} />
              <Route
                path="/shop-coupon-confirm"
                element={<ShopCouponConfirm />}
              />
              <Route
                path="/shop-coupon-success"
                element={<ShopCouponSuccess />}
              />
              {/* <Route path="/test" element={<Test />} /> */}
              <Route path="/member-info" element={<MemberInfoMain />} />
              <Route
                path="/member-info-edit-profile"
                element={<MemberInfoEditProfile />}
              />
              <Route
                path="/member-info-edit-address"
                element={<MemberInfoEditAddress />}
              />
              <Route path="/shop-info" element={<ShopInfoMain />} />
              <Route path="/iframe/copy-tag" element={<CopyTag />} />
              <Route path="/authgame" element={<Game01 />} />
              <Route path="/user-products" element={<UserProducts />} />
              <Route path="/add-products" element={<AddProducts />} />
              <Route path="/notify-repair" element={<NotifyRepair />} />
              <Route path="/products-detail" element={<ProductsDetail />} />
            </Routes>
          </Layouts>
        </ThemeProvider>
      )}
      {!isLoggedIn && (
        <div>
          <CircularProgress />
        </div>
      )}
    </>
  );
}

export default App;
